(function ($) {
	"use strict";

	var App = function () {
		var o = this; // Create reference to this instance
		$(document).ready(function () {
			o.initialize();
		}); // Initialize app when document is ready
	};
	var p = App.prototype;

	// =========================================================================
	// MEMBERS
	// =========================================================================

	// Constant
	App.SCREEN_XS = 480;
	App.SCREEN_SM = 768;
	App.SCREEN_MD = 992;
	App.SCREEN_LG = 1200;

	// Private
	p._callFunctions = null;
	p._resizeTimer = null;
	p._loadOpen = 0;
	p._variables = [];
	p._functions = [];
	// =========================================================================
	// INIT
	// =========================================================================

	p.initialize = function () {
		// Init events
		this._enableEvents();

		// Init base
		this._initBreakpoints();

		// Init components
		this._initInk();

		// Init accordion
		this._initAccordion();

		this._initEventFullScreen();
		this._initEventRefreshToken();
		this._initScrollTabPage();
		this._eventRemoveTabs();
	};

	// =========================================================================
	// EVENTS
	// =========================================================================

	// events
	p._enableEvents = function () {
		var o = this;

		// Window events
		$(window).on("resize", function (e) {
			clearTimeout(o._resizeTimer);
			o._resizeTimer = setTimeout(function () {
				o._handleFunctionCalls(e);
			}, 300);
		});
	};

	// =========================================================================
	// JQUERY-KNOB
	// =========================================================================

	p.getKnobStyle = function (knob) {
		var holder = knob.closest(".knob");
		var options = {
			width: Math.floor(holder.outerWidth()),
			height: Math.floor(holder.outerHeight()),
			fgColor: holder.css("color"),
			bgColor: holder.css("border-top-color"),
			draw: function () {
				if (knob.data("percentage")) {
					$(this.i).val(this.cv + "%");
				}
			},
		};
		return options;
	};

	// =========================================================================
	// ACCORDION
	// =========================================================================

	p._initAccordion = function () {
		$(".panel-group .card .in").each(function () {
			var card = $(this).parent();
			card.addClass("expanded");
		});

		$(".panel-group").on("hide.bs.collapse", function (e) {
			var content = $(e.target);
			var card = content.parent();
			card.removeClass("expanded");
		});

		$(".panel-group").on("show.bs.collapse", function (e) {
			var content = $(e.target);
			var card = content.parent();
			var group = card.closest(".panel-group");

			group.find(".card.expanded").removeClass("expanded");
			card.addClass("expanded");
		});
	};

	// =========================================================================
	// INK EFFECT
	// =========================================================================

	p._initInk = function () {
		var o = this;

		$(".ink-reaction").on("click", function (e) {
			var bound = $(this).get(0).getBoundingClientRect();
			var x = e.clientX - bound.left;
			var y = e.clientY - bound.top;

			var color = o.getBackground($(this));
			var inverse = o.getLuma(color) > 183 ? " inverse" : "";

			var ink = $('<div class="ink' + inverse + '"></div>');
			var btnOffset = $(this).offset();
			var xPos = e.pageX - btnOffset.left;
			var yPos = e.pageY - btnOffset.top;

			ink
				.css({
					top: yPos,
					left: xPos,
				})
				.appendTo($(this));

			window.setTimeout(function () {
				ink.remove();
			}, 1500);
		});
	};

	p.getBackground = function (item) {
		// Is current element's background color set?
		var color = item.css("background-color");
		var alpha = parseFloat(color.split(",")[3], 10);

		if ((isNaN(alpha) || alpha > 0.8) && color !== "transparent") {
			// if so then return that color if it isn't transparent
			return color;
		}

		// if not: are you at the body element?
		if (item.is("body")) {
			// return known 'false' value
			return false;
		} else {
			// call getBackground with parent item
			return this.getBackground(item.parent());
		}
	};

	p.getLuma = function (color) {
		var rgba = color.substring(4, color.length - 1).split(",");
		var r = rgba[0];
		var g = rgba[1];
		var b = rgba[2];
		var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
		return luma;
	};

	// =========================================================================
	// DETECT BREAKPOINTS
	// =========================================================================

	p._initBreakpoints = function (alias) {
		var html = "";
		html += '<div id="device-breakpoints">';
		html += '<div class="device-xs visible-xs" data-breakpoint="xs"></div>';
		html += '<div class="device-sm visible-sm" data-breakpoint="sm"></div>';
		html += '<div class="device-md visible-md" data-breakpoint="md"></div>';
		html += '<div class="device-lg visible-lg" data-breakpoint="lg"></div>';
		html += "</div>";
		$("body").append(html);
	};

	p.isBreakpoint = function (alias) {
		return $(".device-" + alias).is(":visible");
	};
	p.minBreakpoint = function (alias) {
		var breakpoints = ["xs", "sm", "md", "lg"];
		var breakpoint = $("#device-breakpoints div:visible").data("breakpoint");
		return $.inArray(alias, breakpoints) < $.inArray(breakpoint, breakpoints);
	};

	// =========================================================================
	// UTILS
	// =========================================================================

	p.callOnResize = function (func) {
		if (this._callFunctions === null) {
			this._callFunctions = [];
		}
		this._callFunctions.push(func);
		func.call();
	};

	p._handleFunctionCalls = function (e) {
		if (this._callFunctions === null) {
			return;
		}
		for (var i = 0; i < this._callFunctions.length; i++) {
			this._callFunctions[i].call();
		}
	};

	p._initEventFullScreen = function () {
		jQuery("#btn-fullscreen").on("click", function () {
			jQuery(document).toggleFullScreen();
			var btn = jQuery(this);
			if (btn.attr("data-mode") == "off") {
				btn.attr("data-mode", "on");
				btn.children().children().removeClass("icon-IconBWindowMaximize-24");
				btn.children().children().addClass("icon-IconBWindowMinimize-24");
			} else {
				btn.attr("data-mode", "off");
				btn.children().children().removeClass("icon-IconBWindowMinimize-24");
				btn.children().children().addClass("icon-IconBWindowMaximize-24");
			}
		});
	};

	p._initEventRefreshToken = function () {
		setInterval(function () {
			jQuery.ajax({
				type: "get",
				url: window.location.origin + "/token/refresh",
				cache: false,
				success: function (token) {
					jQuery("[name=csrf-token]").attr("content", token);
				},
			});
		}, 1000000);
	};

	/**
	 * @param type
	 * @param url
	 * @param data
	 * @param callbackSuccess
	 * @param callbackError
	 * @param typeBlock
	 * @param {type,pageId} reload
	 * @returns {boolean}
	 * @private
	 */
	p._ajax = function (type, url, data, callbackSuccess, callbackError, typeBlock, reload) {
		var o = this;

		if (!reload) {
			reload = {
				type: null,
			};
		}

		var options = {
			type: type,
			url: url,
			cache: false,
			success: callbackSuccess,
			error: callbackError,
			complete: function (val) {
				if (typeBlock !== false) {
					o._loadOpen--;
					if (o._loadOpen == 0) {
						switch (reload.type) {
							case "card":
								window.gpssat.AppCard.removeCardLoaderPageTab(reload.pageId);
								break;
							default:
								jQuery("#loading").fadeOut("slow", function () {
									jQuery("#loading").css("display", "none");
								});
								break;
						}
					}
				}
			},
			beforeSend: function (val) {
				if (typeBlock !== false) {
					if (o._loadOpen < 1) {
						switch (reload.type) {
							case "card":
								window.gpssat.AppCard.addCardLoaderPageTab(reload.pageId);
								break;
							default:
								jQuery("#loading").css("display", "block");
								break;
						}
					}
					o._loadOpen++;
				}
			},
			statusCode: {
				401: function () {
					location.reload();
				},
				405: function (data) {
					window.gpssat.AppMessage._warning(data.responseJSON.msg);
				},
			},
		};

		if (data) {
			options.data = data;
		}

		jQuery.ajax(options);

		return false;
	};

	p._setValueObject = function (data, path) {
		var nodeName = Object.keys(path);

		for (var i in nodeName) {
			if (typeof path[nodeName[i]] == "object") {
				this._setValueObject(data[nodeName[i]], path[nodeName[i]]);
			} else {
				data[nodeName[i]] = path[nodeName[i]];
			}
		}

		return data;
	};

	p._initScrollTabPage = function () {
		const $tabsContainer = document.querySelector("#tabs-pages");
		if (!$tabsContainer) throw new Error('"#tabs-pages" selector could not be found.');
		const $rightTabScrollArrow = document.querySelector("#scroll-tabs-right");
		if (!$rightTabScrollArrow) throw new Error('"#scroll-tabs-right" selector could not be found.');
		const $leftTabScrollArrow = document.querySelector("#scroll-tabs-left");
		if (!$leftTabScrollArrow) throw new Error('"#scroll-tabs-left" selector could not be found.');
		listenToTabsScroll($rightTabScrollArrow, "right");
		listenToTabsScroll($leftTabScrollArrow, "left");
		let intervalId = 0;
		function listenToTabsScroll($arrow, direction) {
			$arrow.addEventListener("pointerdown", handleStartScroll);
			$arrow.addEventListener("pointerup", handleEndScroll);
			$arrow.addEventListener("pointerleave", handleEndScroll);
			function handleStartScroll() {
				const SCROLL_STEP = 3;
				const SCROLL_INTERVAL = 0;
				clearInterval(intervalId);
				intervalId = setInterval(() => {
					if (direction === "left") $tabsContainer.scrollLeft -= SCROLL_STEP;
					else $tabsContainer.scrollLeft += SCROLL_STEP;
				}, SCROLL_INTERVAL);
			}
			function handleEndScroll() {
				clearInterval(intervalId);
			}
		}
	};

	p._eventRemoveTabs = function () {
		var o = this;
		jQuery("[id=remove-tabs-all]").on("click", function (e) {
			o._ajax("GET", jQuery(this).attr("href"), null, function (val) {
				window.location.href = window.location.origin;
			});

			return false;
		});
	};

	p._formatHourDecimalToTime = function (time) {
		let decimalTime = parseFloat(time);
		if (isNaN(decimalTime)) {
			return "-";
		}
		decimalTime = decimalTime * 60 * 60;
		let hours = Math.floor(decimalTime / (60 * 60));
		decimalTime = decimalTime - hours * 60 * 60;
		let minutes = Math.floor(decimalTime / 60);
		decimalTime = decimalTime - minutes * 60;
		let seconds = Math.round(decimalTime);
		if (hours < 10) {
			hours = "0" + hours;
		}
		if (minutes < 10) {
			minutes = "0" + minutes;
		}
		if (seconds < 10) {
			seconds = "0" + seconds;
		}
		return hours + ":" + minutes + ":" + seconds;
	};

	p._formatMinutesDecimalToTime = function (minutes) {
		var hours = Math.trunc(minutes / 60);
		var minute = Math.round(minutes % 60);
		var minutes_float_to_integer = minute;
		if (hours < 10) {
			hours = "0" + hours;
		}
		if (minutes_float_to_integer < 10) {
			minutes_float_to_integer = "0" + minutes_float_to_integer;
		}
		return hours + ":" + minutes_float_to_integer + ":" + "00";
	};

	p._formatHourTimeToDecimal = function (time) {
		let arr = (time + "").split(":");
		return parseInt(arr[0]) + parseInt(arr[1]) / 60 + parseInt(arr[2]) / 3600;
	};

	p._checkIfItShouldBeFormatedToTime = (pageId, dataPrefix, num) => {
		let htmlElementId = "#decimal_time" + pageId.replace(dataPrefix, "");

		if (!($(htmlElementId).length && $(htmlElementId).is(":checked"))) {
			return gpssat.App._formatHourDecimalToTime(num);
		}
		return num;
	};

	p._checkIfItShouldBeFormatedToDecimal = (pageId, dataPrefix, num) => {
		let htmlElementId = "#decimal_time" + pageId.replace(dataPrefix, "");

		if (!($(htmlElementId).length && $(htmlElementId).is(":checked"))) {
			return gpssat.App._formatHourTimeToDecimal(num);
		}
		return num;
	};

	$(document).ready(() => {
		try {
			if (Number($(".reportsMenu").find("span").css("top").replace("px", "")) > -300) {
				$(".reportsMenu").find("span").css({ top: "0px" });
			}
			if (Number($(".reportsMenu").next("ul").css("top").replace("px", "")) >= -250) {
				$(".reportsMenu").next("ul").css({ top: "" });
			}
		} catch (e) {}
	});

	// =========================================================================
	// DEFINE NAMESPACE
	// =========================================================================

	window.gpssat = window.gpssat || {};
	window.gpssat.App = new App();
})(jQuery); // pass in (jQuery):
